import { render } from "./TrascriptionText.vue?vue&type=template&id=0fc402cf&scoped=true&lang=pug"
import script from "./TrascriptionText.vue?vue&type=script&lang=js"
export * from "./TrascriptionText.vue?vue&type=script&lang=js"

import "./TrascriptionText.vue?vue&type=style&index=0&id=0fc402cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc402cf"]])

export default __exports__